<template>
    <div>
        <FilterStats />
        <TemplateFilterRefinementList
            title="Product"
            attribute="product_type"
            operator="or"
            :expanded-default="true"
            :sort-by="customProductTypeSort"
            :mobile-menu-open="mobileMenuOpen"
        />
        <TemplateFilterRefinementList
            title="Material"
            attribute="material"
            operator="or"
            :expanded-default="false"
            :sort-by="customMaterialSort"
            :mobile-menu-open="mobileMenuOpen"
        />
    </div>
</template>

<script setup lang="ts">
import FilterStats from '~/components/page-building/algolia/FilterStats.vue';
import TemplateFilterRefinementList from '~/components/page-building/template-gallery/components/TemplateFilterRefinementList.vue';

defineProps<{
    mobileMenuOpen: boolean;
}>();

const productTypeOrder = [
    'Gusset Bag',
    'Flat Bottom Bag',
    'Stand Up Pouch',
    'Flat Pouch',
    'Tin Can',
    'Paper Tube',
    'Coffee Bag Label',
    'Beverage Labels',
    'Sticker',
];

const customProductTypeSort = (a, b) => {
    const indexA = productTypeOrder.indexOf(a.name);
    const indexB = productTypeOrder.indexOf(b.name);

    // if not found, send it to the end
    const safeIndexA = indexA === -1 ? productTypeOrder.length : indexA;
    const safeIndexB = indexB === -1 ? productTypeOrder.length : indexB;

    return safeIndexA - safeIndexB;
};

const customMaterialSort = (a, b) => {
    const nameA = a.name;
    const nameB = b.name;
    if (nameA === 'Standard') return -1;
    if (nameB === 'Standard') return 1;
    return nameA.localeCompare(nameB);
};
</script>
